import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

// Home page sections
import Header from './components/Header';
import Hero from './components/Hero';
import Welcome from './components/Welcome';
import VisionMission from './components/VisionMission';
import Services from './components/Services';
import ExpertServices from './components/ExpertServices';
import WorkGallery from './components/WorkGallery';
import Contact from './components/Contact';
import Footer from './components/Footer';

// Pages
import ServicePage from './pages/ServicePage';
import ContactPage from './pages/ContactPage';
import AboutPage from './pages/AboutPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import { WhatsAppFAB } from './pages/ContactPage';

/* ── Scroll to top on every route change ── */
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
};

/* ── Home page assembled ── */
const HomePage = () => (
  <div className="font-sans text-gray-900 bg-white">
    <Header />
    <Hero />
    <Welcome />
    <VisionMission />
    <Services />
    <ExpertServices />
    <WorkGallery />
    <Contact />
  </div>
);

/* ── App with routing ── */
function App() {
  return (
    <Router>
      <ScrollToTop />
      {/* Global floating WhatsApp button — visible on every page */}
      <WhatsAppFAB />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services/:slug" element={<ServicePage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/terms" element={<TermsPage />} />
        {/* Catch-all → home */}
        <Route path="*" element={<HomePage />} />
      </Routes>
      {/* Global footer — visible on every page */}
      <Footer />
    </Router>
  );
}

export default App;
